import React, { useEffect, useState } from 'react'
// import Modal from '../../../components/Modal'
import Modal from 'react-responsive-modal'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Input, Select, Textarea } from '../../../components/ModalInputs'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import Table from '../../../components/Table'
import { createParentMeetings, getParentMeetingsById, getParentMeetingsRooms, updateParentMeetings } from '../../../actions/parent_meetings'
import TeacherModal from './EnrollModal/TeacherModal'
import { getSchoolClassByYear } from '../../../actions/common'
import moment from 'moment'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Main from './Tabs/Main'
import Files from './Tabs/Files'


const validationSchema = Yup.object().shape({
  date: Yup.string().required('обязательное поле'),
  begintime: Yup.string().required('обязательное поле'),
  endtime: Yup.string().required('обязательное поле')
})

export default function ModalComponent({ data, closeModal, params, addMode }) {

  const dispatch = useDispatch()
  const { schoolYears, classesByYear } = useSelector(state => state.common)
  const { parentMeetingsRooms, parentMeetingsTeachers, parentMeetingsId } = useSelector(state => state.parent_meetings)

  const [openEnrollModal, setOpenEnrollModal] = useState(false)
  const [selectedClasses, setSelectedClasses] = useState([])

  // useEffect(() => {
  //   !addMode && parentMeetingsTeachers && setSelectedClasses(parentMeetingsTeachers)
  // }, [parentMeetingsTeachers])

  useEffect(() => {
    dispatch(getParentMeetingsRooms())
    data?.pmid && dispatch(getParentMeetingsById(data?.pmid))
  }, [data?.pmid])

  useEffect(() => {
    data && data.classes && setSelectedClasses(classesByYear.filter(el => data.classes.find(num => num == el.name)))
  }, [data])

  useEffect(() => {
    if (params.year) {
      // dispatch(getParentMeetingsList(formData))
      dispatch(getSchoolClassByYear(params.year))
    }
  }, [params])

  // const handleChangeStudents = (student) => {
  //   if (typeof student === 'number') setSelectedClasses((prev) => prev.filter(el => el.mid !== student))
  //   else setSelectedClasses((prev) => !prev.includes(student.mid) ? [...prev, student] : prev.toSpliced(prev.indexOf(student), 1))
  // }
  const handleChangeClasses = (clas) => {
    if (selectedClasses?.length === 0) {
      setSelectedClasses([clas])
    }
    else {
      if (typeof clas === 'number') setSelectedClasses((prev) => prev.filter(el => el.mid !== clas))
      else setSelectedClasses((prev) => !prev?.find(stud => stud.gid === clas.gid) ? [...prev, clas] : prev.toSpliced(prev.indexOf(clas), 1))
    }
  }

  const handleCreate = (values) => {
    const classesId = !!selectedClasses && selectedClasses?.map(el => el.gid)
    dispatch(createParentMeetings({ ...values, classes: classesId }, params))
    closeModal()
    resetForm()
    setSelectedClasses([])
  }

  const handleUpdate = async (values) => {
    // const { week_id, ...payload } = values
    const classesId = !!selectedClasses && selectedClasses?.map(el => el.gid)
    await dispatch(updateParentMeetings({ ...values, classes: classesId, date: moment(values.date).format('YYYY-MM-DD') }))
    closeModal()
    resetForm()
    setSelectedClasses([])
  }
  const openEnroll = () => {
    setOpenEnrollModal(classesByYear)
  }
  const closeEnroll = () => {
    setOpenEnrollModal(false)
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? { date: moment().format('YYYY-MM-DD') } : data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate,
  })
  const renderLi = (data) => {
    const { name, gid } = data
    return (
      <tr key={gid}>
        <td>{name}</td>
      </tr>
    )
  }

  // const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      {/* {openEnrollModal &&
        <TeacherModal
          closeModal={closeEnroll}
          data={openEnrollModal}
          height={'430px'}
          handleChangeClasses={handleChangeClasses}
          selectedClasses={selectedClasses}
        />
      } */}
      <Tabs className={styles.tabs}>
        <TabList className={styles.tabsBlock}>
          <Tab className={styles.tab} selectedClassName={styles.activeTab}>Главная</Tab>
          <Tab className={styles.tab} selectedClassName={styles.activeTab}>Файлы</Tab>
        </TabList>
        <TabPanel>
          <Main
            params={params}
            data={data}
            closeModal={closeModal}
            addMode={addMode}
            values={values}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            handleBlur={handleBlur}
            submitCount={submitCount}
            handleSubmit={handleSubmit}
            handleChangeClasses={handleChangeClasses}
            setSelectedClasses={setSelectedClasses}
            selectedClasses={selectedClasses}
            openEnrollModal={openEnroll}
            closeEnroll={closeEnroll} />
        </TabPanel>
        <TabPanel>
          <Files params={params} data={data} closeModal={closeModal} handleSubmit={handleSubmit} />
        </TabPanel>
      </Tabs>
    </Modal>
  )
}
